// Global modal manager to prevent multiple modals
let activeModal = null;

class CustomerAccountModal extends HTMLElement {
  constructor() {
    super();
    this.wrapper = this.querySelector('.customer-account_modal-wrapper');
    this.recoverContainer = this.querySelector('.password-recover');
    this.loginForm = this.querySelector('#login');
    this.verifyForm = this.querySelector('#verify');
    this.resetForm = this.querySelector('#reset');
    this.deliveryForm = this.querySelector('#delivery');
    this.successForm = this.querySelector('#success');
    this.currentForm = 'login'; // Default form
    this.isActive = false;
    this.baseServerURL = 'https://app.cannacabana.com';
    this.userEmail = ''; // Store user email for verification
    this.otpToken = ''; // Store OTP token for password reset
    this.userPhone = ''; // Store user phone for signup
    this.isForcedPasswordResetFlow = false; // needs_password_reset immediate recover path

    console.log('Modal instance created:', this);
  }

  connectedCallback() {
    console.log('Modal connected:', this);
    this.bindCloseButton();
    this.bindNavigation();
    this.bindExternalTriggers();
    this.bindFormSubmissions();
    // Ensure only login form is visible by default
    this.hideAllForms();
    this.showForm('login');
  }


  async getAccessToken() {
    const stored = localStorage.getItem('canna_access_token');
    const expiry = localStorage.getItem('canna_access_token_expiry');

    if (stored && expiry && Date.now() < Number(expiry)) {
      return stored;
    }

    const response = await fetch(`${this.baseServerURL}/oauth/token`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({
        client_id: '7',
        client_secret: 'dqo3pUrSPyN0ONslDAzw1oHaxXs5KZ3D38DcNqLa',
        grant_type: 'client_credentials',
      }),
    });

    if (!response.ok) {
      throw new Error('Failed to retrieve access token');
    }

    const data = await response.json();

    localStorage.setItem('canna_access_token', data.access_token);
    localStorage.setItem(
      'canna_access_token_expiry',
      Date.now() + data.expires_in * 1000
    );

    return data.access_token;
  }

  normalizeCheckCustomerIdentifier(value) {
    const raw = (value || '').trim();
    if (!raw) return '';
    if (raw.includes('@')) return raw;

    const digits = raw.replace(/\D/g, '');
    if (digits.length === 10) return `+1${digits}`;
    if (digits.length === 11 && digits.startsWith('1')) return `+${digits}`;
    if (raw.startsWith('+') && digits.length >= 11) return `+${digits}`;
    return raw;
  }

  applyRecoverCopy() {
    const titleEl = this.querySelector('.recover-title');
    const textEl = this.querySelector('.recover-text');
    const ctaBtn = this.querySelector('#recover-submit-btn');

    if (this.isForcedPasswordResetFlow) {
      if (titleEl) titleEl.textContent = 'Password Reset Required';
      if (textEl) {
        textEl.textContent = 'Due to a recent update, you’ll need to reset your password. Enter your email to receive your reset code.';
      }
      if (ctaBtn) ctaBtn.textContent = 'Send Code';
    } else {
      if (titleEl) titleEl.textContent = 'Recover Password';
      if (textEl) {
        textEl.textContent = 'An email will be sent to you shortly to change your password.';
      }
      if (ctaBtn) ctaBtn.textContent = 'Submit';
    }
  }

  async checkCustomer(emailOrPhone, isSignup = false) {
    try {
      const isEmailInput = emailOrPhone.includes('@');
      if (isEmailInput) {
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailOrPhone)) {
          this.showError('Please enter a valid email.');
          return false;
        }
      } else {
        const digits = emailOrPhone.replace(/\D/g, '');
        if (digits.length < 10) {
          this.showError('Please enter a valid email or phone number.');
          return false;
        }
      }

      const accessToken = await this.getAccessToken();
      console.log('Access token used:', accessToken);
      const response = await fetch(`${this.baseServerURL}/api/shopify-auth/check-customer`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          email: emailOrPhone
        })
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      console.log('Customer check response:', data);

      if (data.success) {
        console.log('Full data object:', data);
        console.log('data.data:', data.data);
        console.log('data.data.is_exists:', data.data.is_exists);

        const isExists = data.data.is_exists;
        const needsPasswordReset = data.data.customer && Number(data.data.customer.needs_password_reset) === 1;
        console.log('isExists value:', isExists, 'Type:', typeof isExists);

        // Handle both string and boolean values
        const userExists = isExists === true || isExists === 'true';
        const userNotExists = isExists === false || isExists === 'false';

        console.log('userExists:', userExists);
        console.log('userNotExists:', userNotExists);

        if (userNotExists) {
          this.isForcedPasswordResetFlow = false;
          // Login flow: user not found → close login modal and open Cabana sign-up at Step 2 (skip Step 1)
          console.log('User not found - opening sign-up popup at Step 2');
          this.hideError();
          this.closeModal();
          if (typeof window.openCabanaPopupAtStep2 === 'function') {
            window.openCabanaPopupAtStep2(emailOrPhone);
          }
          return true;
        }

        if (userExists) {
          if (isSignup) {
            // For signup: if user exists, show error
            console.log('User exists during signup - showing error message');
            this.showError('User already exists. Please sign in instead.');
            return false;
          } else {
            // For login: if user exists, proceed to next step
            console.log('User exists during login - proceeding to next step');

            // Capture customer data for later use
            if (data.data.customer) {
              this.capturedCustomerData = data.data.customer;
              console.log('Captured customer data:', this.capturedCustomerData);

              // Store email for password validation
              if (data.data.customer.email) {
                this.customerEmail = data.data.customer.email;
                console.log('Stored customer email for validation:', this.customerEmail);
              }
            }

            this.hideError();

            // New backend flag: if needs_password_reset === 1, send user directly to Recover screen
            if (needsPasswordReset) {
              console.log('User requires password reset – showing recover form instead of password step');
              this.isForcedPasswordResetFlow = true;
              this.showForm('recover');
            } else {
              this.isForcedPasswordResetFlow = false;
              this.showNextStep();
            }
            return true;
          }
        } else {
          if (isSignup) {
            this.isForcedPasswordResetFlow = false;
            // For signup: if user doesn't exist, proceed to delivery options
            console.log('User doesn\'t exist during signup - proceeding to delivery options');
            this.hideError();
            this.showDeliveryOptionsScreen(emailOrPhone);
            return true;
          }
        }

        // This should never be reached, but just in case
        console.log('Unexpected state - isExists value:', isExists);
        this.showError('Invalid response from server. Please try again.');
        return false;
      } else {
        console.log('API returned success: false');
        this.showError(data.message || 'Something went wrong. Please try again.');
        return false;
      }
    } catch (error) {
      console.error('Error checking customer:', error);
      this.showError('Network error. Please try again.');
      return false;
    }
  }

  showError(message) {
    console.log('showError called with message:', message);

    // Remove existing error
    this.hideError();

    // Create error element
    const errorDiv = document.createElement('div');
    errorDiv.className = 'field-error-message';
    errorDiv.innerHTML = `
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="8" cy="8" r="8" fill="#F26857"/>
        <path d="M8 4V8M8 12H8.01" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
      </svg>
      <span>${message}</span>
    `;

    // Try multiple selectors to find the current input
    let currentInput = null;
    let inputContainer = null;

    // First, determine which form is currently active
    const currentForm = this.currentForm;
    console.log('Current active form:', currentForm);

    if (currentForm === 'signup') {
      // For signup form, look for SignupEmail
      currentInput = this.querySelector('#SignupEmail');
      if (currentInput) {
        inputContainer = currentInput.closest('.welcome_field') || currentInput.parentNode;
        console.log('Found signup input (SignupEmail):', currentInput);
      }
    } else if (currentForm === 'login') {
      // For login form, look for CustomerEmail
      currentInput = this.querySelector('#CustomerEmail');
      if (currentInput) {
        inputContainer = currentInput.closest('.login_field') || currentInput.parentNode;
        console.log('Found login input (CustomerEmail):', currentInput);
      }
    } else if (currentForm === 'verify') {
      // For verification form, look for code input container
      const codeInputContainer = this.querySelector('.code-input-container');
      if (codeInputContainer) {
        inputContainer = codeInputContainer;
        console.log('Found verification form code input container:', codeInputContainer);
      }
    }

    // Fallback: find any visible input if the above didn't work
    if (!currentInput) {
      const allInputs = this.querySelectorAll('input[type="text"], input[type="email"]');
      for (let input of allInputs) {
        if (input.offsetParent !== null) { // Check if input is visible
          currentInput = input;
          inputContainer = input.parentNode;
          console.log('Found visible input as fallback:', input);
          break;
        }
      }
    }

    console.log('Current input found:', currentInput);
    console.log('Input container found:', inputContainer);

    if (currentInput && inputContainer) {
      // Add error styling to input using CSS class
      currentInput.classList.add('field-error');

      // Add error message after the input container
      inputContainer.appendChild(errorDiv);
      console.log('Error message added to DOM');

      // Force a reflow to ensure styles are applied
      currentInput.offsetHeight;
      errorDiv.offsetHeight;

      // Scroll to error if needed
      errorDiv.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

      // Add a test alert to confirm error is being shown
      setTimeout(() => {
        console.log('Error element in DOM:', errorDiv);
        console.log('Error element visible:', errorDiv.offsetParent !== null);
        console.log('Error element styles:', window.getComputedStyle(errorDiv));
      }, 100);
    } else {
      console.log('No input field found to attach error message');
      // Fallback: add error to modal body
      const modalBody = this.querySelector('.customer-account_modal-wrapper');
      if (modalBody) {
        modalBody.appendChild(errorDiv);
        console.log('Error message added to modal body as fallback');
      }
    }
  }

  showPasswordError(message) {
    console.log('showPasswordError called with message:', message);
    this.hideError();

    const passwordInput = this.querySelector('#CustomerPassword');
    if (!passwordInput) {
      this.showError(message);
      return;
    }

    const inputContainer = passwordInput.closest('.login_field') || passwordInput.parentNode;
    const errorDiv = document.createElement('div');
    errorDiv.className = 'field-error-message';
    errorDiv.innerHTML = `
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="8" cy="8" r="8" fill="#F26857"/>
        <path d="M8 4V8M8 12H8.01" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
      </svg>
      <span>${message}</span>
    `;

    passwordInput.classList.add('field-error');
    if (inputContainer) {
      inputContainer.appendChild(errorDiv);
    } else {
      this.appendChild(errorDiv);
    }
  }

  hideError() {
    // Remove error styling from input
    const inputs = this.querySelectorAll('input');
    inputs.forEach(input => {
      input.classList.remove('field-error');
      input.style.border = '1px solid #ccc'; // Reset border
      input.style.borderRadius = '4px'; // Reset border-radius
    });

    // Remove error messages
    const errorMessages = this.querySelectorAll('.field-error-message');
    errorMessages.forEach(error => {
      error.remove();
    });
  }

  showNextStep() {
    // Show password input field for next step
    const currentForm = this.currentForm;

    if (currentForm === 'signup') {
      // For signup: show password creation screen
      this.showPasswordCreationScreen();
    } else if (currentForm === 'login') {
      // For login: show password field
      this.showLoginPasswordStep();
    }
  }

  showPasswordCreationScreen() {
    console.log('Showing password creation screen');

    // Show password reset form (reuse for password creation)
    this.showForm('reset');

    // Update button text to "Sign Up"
    const resetButton = this.querySelector('#reset-password-button');
    if (resetButton) {
      resetButton.textContent = 'Sign Up';
    }

    // Focus on first password input
    setTimeout(() => {
      const firstPasswordInput = this.querySelector('#NewPassword');
      if (firstPasswordInput) {
        firstPasswordInput.focus();
      }
    }, 100);
  }

  showSuccessScreen() {
    console.log('Showing success screen');

    // Update welcome message with user's name
    const successWelcome = this.querySelector('#success-welcome-name');
    if (successWelcome) {
      const name = this.userEmail.split('@')[0]; // Extract name from email
      successWelcome.textContent = name;
    }

    // Show success form
    this.showForm('success');
  }

  showLoginPasswordStep() {
    const passwordField = this.querySelector('.login_field.next-step');
    const submitBtn = this.querySelector('.field-other.next-step');
    const loginHeading = this.querySelector('.login_title-info');
    const forgotLinkWrap = this.querySelector('#login-forgot-password-wrap');
    const emailInput = this.querySelector('#CustomerEmail');

    // Show password field
    if (passwordField) {
      passwordField.classList.remove('hide');
    }

    // On second step, adjust placeholder to email example
    if (emailInput) {
      emailInput.placeholder = 'example@gmail.com';
    }

    // Show "Forgot your password?" link when password step is visible (normal flow)
    if (forgotLinkWrap) {
      forgotLinkWrap.classList.remove('hide');
      forgotLinkWrap.style.display = '';
    }

    // Never show the outline Sign in button
    if (submitBtn) {
      submitBtn.classList.add('hide');
    }

    // Hide "Sign in with your..." heading
    if (loginHeading) {
      loginHeading.classList.add('hide');
    }
  }



  async validatePassword() {
    const emailInput = this.querySelector('#CustomerEmail');
    const passwordInput = this.querySelector('#CustomerPassword');

    const emailVal = emailInput && emailInput.value ? emailInput.value.trim() : '';
    const passwordVal = passwordInput && passwordInput.value ? passwordInput.value.trim() : '';

    // Both fields empty
    if (!emailVal && !passwordVal) {
      // Show combined message under the password field
      this.showPasswordError('Please enter your email and password.');
      if (emailInput) emailInput.classList.add('field-error');
      if (passwordInput) passwordInput.classList.add('field-error');
      return false;
    }

    // Email empty only
    if (!emailVal) {
      this.showError('Please enter your email.');
      if (emailInput) emailInput.classList.add('field-error');
      return false;
    }

    // Email present: keep internal state in sync
    this.customerEmail = emailVal;

    // Password empty only
    if (!passwordVal) {
      this.showPasswordError('Please enter your password.');
      if (passwordInput) passwordInput.classList.add('field-error');
      return false;
    }

    const password = passwordVal;
    console.log('Validating password for email:', this.customerEmail);

    try {
      const accessToken = await this.getAccessToken();
      console.log('Access token used:', accessToken);

      const response = await fetch(`${this.baseServerURL}/api/shopify-auth/login`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: this.customerEmail,
          password: password,
          redirectUrl: 'https://cannacabana.com/account'
        })
      });

      let data = null;
      try {
        data = await response.json();
      } catch (e) {
        console.warn('Login response was not JSON:', e);
      }

      console.log('Login response:', data);

      if (!response.ok) {
        const msg = (data && data.message) ? data.message : 'Invalid email or password.';
        this.showPasswordError(msg);
        return false;
      }

      if (data && data.returnUrl) {
        console.log('Redirecting to returnUrl:', data.returnUrl);
        window.location.href = data.returnUrl; // redirect to create session
        return true;
      }

      if (data && data.success) {
        console.log('Login successful');
        this.hideError();
        this.showSuccess('Login successful!');
        return true;
      }

      const fallbackMsg = (data && data.message) ? data.message : 'Invalid email or password.';
      this.showPasswordError(fallbackMsg);
      return false;
    } catch (error) {
      console.error('Error during login:', error);
      this.showPasswordError('Network error. Please try again.');
      return false;
    }
  }


  async recoverPassword(email) {
    console.log('=== RECOVER PASSWORD DEBUG START ===');
    console.log('Recovering password for email:', email);
    console.log('Current form type:', this.currentForm);

    try {
      const accessToken = await this.getAccessToken();

      // Create form data
      const formData = new FormData();
      formData.append('email', email);

      // Call recover password API
      const response = await fetch(`${this.baseServerURL}/api/shopify-auth/forgot-password`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
          'Accept': 'application/json'
          // Note: Don't set Content-Type for FormData, browser sets it automatically
        },
        body: formData
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      console.log('Recover password response:', data);

      if (data.success) {
        console.log('Password recovery initiated successfully');
        this.hideError();
        this.hideRecoverError();
        // Store email for subsequent reset/login
        this.userEmail = email;
        // Move user to Reset Password screen (code/OTP + new password + confirm)
        this.showForm('reset');
        console.log('=== RECOVER PASSWORD DEBUG END ===');
        return true;
      } else {
        console.log('Password recovery failed:', data.message);
        this.showRecoverError(data.message || 'Failed to send recovery email. Please try again.');
        console.log('=== RECOVER PASSWORD DEBUG END ===');
        return false;
      }
    } catch (error) {
      console.error('Error during password recovery:', error);
      this.showRecoverError('Network error. Please try again.');
      console.log('=== RECOVER PASSWORD DEBUG END ===');
      return false;
    }
  }

  showRecoverError(msg) {
    const el = this.querySelector('#recover-error');
    if (el) {
      el.textContent = msg;
      el.style.display = 'block';
    }
  }

  hideRecoverError() {
    const el = this.querySelector('#recover-error');
    if (el) {
      el.textContent = '';
      el.style.display = 'none';
    }
  }

  showRecoverSuccessMessage() {
    const container = this.querySelector('#login-recover-success');
    if (!container) return;
    const message = "We've emailed you instructions to reset your password. Please check your inbox.";
    container.innerHTML = `
      <div class="login-recover-success__inner">
        <span class="login-recover-success__icon" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
        </span>
        <span>${message}</span>
      </div>
    `;
    container.style.display = 'block';
  }

  showPasswordChangeSuccessMessage() {
    const container = this.querySelector('#login-recover-success');
    if (!container) return;
    const message = 'Your password has been successfully updated. Please sign in with your new password.';
    container.innerHTML = `
      <div class="login-recover-success__inner">
        <span class="login-recover-success__icon" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
        </span>
        <span>${message}</span>
      </div>
    `;
    container.style.display = 'block';

    if (this._passwordChangeTimeout) {
      clearTimeout(this._passwordChangeTimeout);
    }
    this._passwordChangeTimeout = setTimeout(() => {
      container.innerHTML = '';
      container.style.display = 'none';
    }, 5000);
  }

  updateResetButtonState() {
    const btn = this.querySelector('#reset-password-button');
    if (!btn) return;
    const code = this.querySelector('#ResetCode')?.value.trim() || '';
    const password = this.querySelector('#NewPassword')?.value || '';
    const confirm = this.querySelector('#ConfirmPassword')?.value || '';

    const isValid =
      code.length > 0 &&
      password.length >= 6 &&
      confirm.length >= 6 &&
      password === confirm;

    btn.disabled = !isValid;
  }

  setButtonLoading(btn, isLoading) {
    if (!btn) return;
    if (isLoading) {
      if (!btn.dataset.originalText) btn.dataset.originalText = btn.textContent;
      btn.classList.add('btn-loading');
      btn.disabled = true;
      btn.textContent = '';
    } else {
      btn.classList.remove('btn-loading');
      if (btn.dataset.originalText) btn.textContent = btn.dataset.originalText;
      btn.disabled = false;
    }
  }

  showSignupInputScreen() {
    console.log('Showing signup input screen');

    // Create a simple signup input screen
    const signupHTML = `
      <div class="welcome-header">
        <div class="welcome-icon">
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M24 4L29.09 16.26L42 18L29.09 19.74L24 32L18.91 19.74L6 18L18.91 16.26L24 4Z" fill="#F26857"/>
          </svg>
        </div>
        <h1 class="welcome-title">Create Account</h1>
      </div>

      <div class="welcome-content">
        <p class="welcome-text">
          Sign in with your <strong>email</strong> or <strong>phone number</strong>, or create an account to become a Cabana Club Member.
        </p>

        <div class="field welcome_field">
          <label for="SignupEmail">Email or Phone Number</label>
          <input
            type="text"
            name="signup_email"
            id="SignupEmail"
            placeholder="Enter phone number or email address"
            autocomplete="email"
            autocorrect="off"
            autocapitalize="off"
            title="Please enter a valid email address or phone number"
            required>
        </div>

        <div class="field-other">
          <button class="button button--primary signup-continue" id="signup-continue-button">
            Continue
          </button>
        </div>

        <div class="legal-links">
          <a href="/pages/terms-conditions" class="legal-link">Terms & Conditions</a>
          <span class="legal-separator">|</span>
          <a href="/pages/privacy-policy" class="legal-link">Privacy Policy</a>
        </div>
      </div>
    `;

    // Replace the login form content with signup content
    if (this.loginForm) {
      this.loginForm.innerHTML = signupHTML;
      this.loginForm.style.display = 'block';
      this.currentForm = 'signup';

      // Bind the signup continue button
      const signupContinueBtn = this.querySelector('#signup-continue-button');
      if (signupContinueBtn) {
        signupContinueBtn.addEventListener('click', async (e) => {
          e.preventDefault();
          const input = this.querySelector('#SignupEmail');
          if (input && input.value.trim()) {
            await this.checkCustomer(input.value.trim(), true); // true for signup
          } else {
            this.showError('Please enter an email or phone number');
          }
        });
      }

      // Focus on input
      setTimeout(() => {
        const input = this.querySelector('#SignupEmail');
        if (input) {
          input.focus();
        }
      }, 100);
    }
  }

  showDeliveryOptionsScreen(emailOrPhone) {
    console.log('Showing delivery options screen for:', emailOrPhone);

    // Store user contact info
    this.userEmail = emailOrPhone;
    this.userPhone = emailOrPhone;

    // Update welcome message with user's name
    const welcomeName = this.querySelector('#delivery-welcome-name');
    if (welcomeName) {
      const name = emailOrPhone.split('@')[0]; // Extract name from email
      welcomeName.textContent = `Welcome ${name}!`;
    }

    // Update delivery email display
    const deliveryEmailSpan = this.querySelector('#delivery-email');
    if (deliveryEmailSpan) {
      deliveryEmailSpan.textContent = emailOrPhone;
    }

    // Show delivery options form
    this.showForm('delivery');
  }

  showVerificationScreen() {
    console.log('Showing verification screen for email:', this.userEmail);

    // Update welcome message with user's name (extract from email)
    const welcomeName = this.querySelector('#welcome-name');
    if (welcomeName) {
      const name = this.userEmail.split('@')[0]; // Extract name from email
      welcomeName.textContent = `Welcome ${name}!`;
    }

    // Update user email display
    const userEmailSpan = this.querySelector('#user-email');
    if (userEmailSpan) {
      userEmailSpan.textContent = this.userEmail;
    }

    // Show verification form
    this.showForm('verify');

    // Initialize button state (disabled initially)
    this.updateVerifyButtonState();

    // Focus on first code input
    setTimeout(() => {
      const firstInput = this.querySelector('.code-input[data-index="0"]');
      if (firstInput) {
        firstInput.focus();
      }
    }, 100);
  }

  updateVerifyButtonState() {
    const codeInputs = this.querySelectorAll('.code-input');
    const verifyButton = this.querySelector('#verify-continue-button');

    if (!verifyButton) return;

    // Check if all 4 inputs have values
    const allFilled = Array.from(codeInputs).every(input => input.value.length === 1);

    if (allFilled) {
      // Enable button
      verifyButton.disabled = false;
      verifyButton.classList.remove('disabled');
      verifyButton.style.backgroundColor = '#F26857';
      verifyButton.style.cursor = 'pointer';
    } else {
      // Disable button
      verifyButton.disabled = true;
      verifyButton.classList.add('disabled');
      verifyButton.style.backgroundColor = '#ccc';
      verifyButton.style.cursor = 'not-allowed';
    }
  }

  showPasswordResetScreen() {
    console.log('Showing password reset screen');

    // Show password reset form
    this.showForm('reset');

    // Focus on first password input
    setTimeout(() => {
      const firstPasswordInput = this.querySelector('#NewPassword');
      if (firstPasswordInput) {
        firstPasswordInput.focus();
      }
    }, 100);
  }

  async loginAfterPasswordReset(newPassword) {
    console.log('Logging in user after password reset');

    try {
      const accessToken = await this.getAccessToken();
      console.log('Access token used:', accessToken);
      const response = await fetch(`${this.baseServerURL}/api/shopify-auth/login`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: this.userEmail,
          password: newPassword,
          redirectUrl: 'https://cannacabana.com/account'
        })
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      console.log('Login after password reset response:', data);

      if (data.success) {
        console.log('User logged in successfully after password reset');
        this.hideError();

        // Close modal
        this.closeModal();

        // Reload the page to update the user state
        setTimeout(() => {
          window.location.reload();
        }, 1000);

        return true;
      } else {
        console.log('Login failed after password reset:', data.message);
        this.showError('Password reset successful but login failed. Please try logging in manually.');
        return false;
      }
    } catch (error) {
      console.error('Error during login after password reset:', error);
      this.showError('Password reset successful but login failed. Please try logging in manually.');
      return false;
    }
  }

  async sendSignupCode() {
    const selectedMethod = this.querySelector('input[name="delivery-method"]:checked').value;
    console.log('Sending signup code via:', selectedMethod);

    try {
      const accessToken = await this.getAccessToken();

      // Create form data (same as forgot password API)
      const formData = new FormData();
      formData.append('email', this.userEmail);

      const response = await fetch(`${this.baseServerURL}/api/shopify-auth/forgot-password`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
          'Accept': 'text/json'
        },
        body: formData
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      console.log('Send signup code response:', data);

      if (data.success) {
        console.log('Signup code sent successfully');
        this.hideError();
        // Show verification screen
        this.showVerificationScreen();
        return true;
      } else {
        console.log('Send signup code failed:', data.message);
        this.showError(data.message || 'Failed to send code. Please try again.');
        return false;
      }
    } catch (error) {
      console.error('Error during send signup code:', error);
      this.showError('Network error. Please try again.');
      return false;
    }
  }

  async resetPassword() {
    const codeInput = this.querySelector('#ResetCode');
    const code = codeInput ? codeInput.value.trim() : '';
    const newPassword = this.querySelector('#NewPassword').value;
    const confirmPassword = this.querySelector('#ConfirmPassword').value;

    // As per UX request: no inline validation errors here,
    // button should be disabled until fields are valid.
    console.log('Resetting password with code:', code);

    try {
      const accessToken = await this.getAccessToken();

      const response = await fetch(`${this.baseServerURL}/api/shopify-auth/reset-password`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          otp: code,
          email: this.userEmail,
          password: newPassword,
          password_confirmation: confirmPassword
        })
      });

      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        const msg = data.message || 'Failed to reset password. Please try again.';
        this.showError(msg);
        return false;
      }

      console.log('Reset password response:', data);

      if (data.success) {
        console.log('Password reset successfully');
        this.hideError();
        // After successful reset, return to login screen and show success message
        this.showForm('login');
        this.showPasswordChangeSuccessMessage();
        return true;
      } else {
        console.log('Password reset failed:', data.message);
        this.showError(data.message || 'Failed to reset password. Please try again.');
        return false;
      }
    } catch (error) {
      console.error('Error during password reset:', error);
      this.showError('Network error. Please try again.');
      return false;
    }
  }

  async verifyCode() {
    const codeInputs = this.querySelectorAll('.code-input');
    const token = Array.from(codeInputs).map(input => input.value).join('');

    if (token.length !== 4) {
      this.showError('Please enter the complete 4-digit code');
      return;
    }

    console.log('Verifying OTP token:', token, 'for email:', this.userEmail);

    try {
      const accessToken = await this.getAccessToken();

      const response = await fetch(`${this.baseServerURL}/api/shopify-auth/verify-otp`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          token: token,
          email: this.userEmail
        })
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      console.log('Verify OTP response:', data);

      if (data.success) {
        console.log('OTP verified successfully');
        this.hideError();

        // Store the OTP token for password reset
        this.otpToken = token;

        // Show password reset screen
        this.showPasswordResetScreen();
        return true;
      } else {
        console.log('OTP verification failed:', data.message);
        this.showError(data.message || 'Invalid code. Please try again.');
        return false;
      }
    } catch (error) {
      console.error('Error during OTP verification:', error);
      this.showError('Network error. Please try again.');
      return false;
    }
  }



  showSuccess(message) {
    console.log('=== SHOW SUCCESS DEBUG START ===');
    console.log('showSuccess called with message:', message);
    console.log('Current form type:', this.currentForm);

    // Create success message using error styling (red color)
    const successDiv = document.createElement('div');
    successDiv.className = 'field-error-message';
    successDiv.innerHTML = `
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="8" cy="8" r="8" fill="#F26857"/>
        <path d="M6 8L7.5 9.5L10 7" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span>${message}</span>
    `;

    // Find the current input based on which form is active
    let currentInput = null;

    if (this.currentForm === 'recover') {
      // For password recovery form
      currentInput = this.querySelector('#RecoverEmail');
      console.log('Looking for #RecoverEmail, found:', currentInput);
    } else if (this.currentForm === 'signup') {
      // For signup form
      currentInput = this.querySelector('#SignupEmail');
      console.log('Looking for #SignupEmail, found:', currentInput);
    } else if (this.currentForm === 'login') {
      // For login form
      currentInput = this.querySelector('#CustomerEmail');
      console.log('Looking for #CustomerEmail, found:', currentInput);
    }

    if (currentInput) {
      currentInput.parentNode.appendChild(successDiv);
      console.log('Success message added for form:', this.currentForm);
      console.log('Success div created:', successDiv);
      console.log('Success div HTML:', successDiv.outerHTML);
    } else {
      console.log('No input field found for current form:', this.currentForm);
      // Fallback: add to modal body
      const modalBody = this.querySelector('.customer-account_modal-wrapper');
      if (modalBody) {
        modalBody.appendChild(successDiv);
        console.log('Success message added to modal body as fallback');
      } else {
        console.log('No modal body found either!');
      }
    }
    console.log('=== SHOW SUCCESS DEBUG END ===');
  }

  bindFormSubmissions() {

    // Bind continue button for login form
    const loginContinueBtn = this.querySelector('.next-step-btn .button');
    if (loginContinueBtn) {
      loginContinueBtn.addEventListener('click', async (e) => {
        e.preventDefault();

        const passwordFieldVisible =
          !this.querySelector('.login_field.next-step')?.classList.contains('hide');

        if (passwordFieldVisible) {
          // Second step → submit password
          await this.validatePassword();
          return;
        }

        // First step → check customer
        const input = this.querySelector('#CustomerEmail');
        if (input && input.value.trim()) {
          await this.checkCustomer(input.value.trim(), false);
        } else {
          this.showError('Enter an email or phone number');
        }
      });
    }

    // Bind login submit button for password validation
    const loginSubmitBtn = this.querySelector('#login-submit-button');
    if (loginSubmitBtn) {
      loginSubmitBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        this.setButtonLoading(loginSubmitBtn, true);
        try {
          await this.validatePassword();
        } finally {
          this.setButtonLoading(loginSubmitBtn, false);
        }
      });
    }

    // Bind recover password button
    const recoverPasswordBtn = this.querySelector('#recover-submit-btn') || this.querySelector('.password-recover .button');
    if (recoverPasswordBtn) {
      recoverPasswordBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        const emailInput = this.querySelector('#RecoverEmail');
        const email = emailInput && emailInput.value.trim();
        if (!email) {
          this.showRecoverError('Please enter your email address');
          return;
        }
        this.hideRecoverError();
        this.setButtonLoading(recoverPasswordBtn, true);
        try {
          await this.recoverPassword(email);
        } finally {
          this.setButtonLoading(recoverPasswordBtn, false);
        }
      });
    }

    // Bind code verification inputs
    const codeInputs = this.querySelectorAll('.code-input');
    const verifyButton = this.querySelector('#verify-continue-button');

    codeInputs.forEach((input, index) => {
      input.addEventListener('input', (e) => {
        const value = e.target.value;
        if (value.length === 1) {
          // Move to next input
          if (index < codeInputs.length - 1) {
            codeInputs[index + 1].focus();
          }
        }

        // Check if all inputs are filled and update button state
        this.updateVerifyButtonState();
      });

      input.addEventListener('keydown', (e) => {
        if (e.key === 'Backspace' && e.target.value === '') {
          // Move to previous input on backspace
          if (index > 0) {
            codeInputs[index - 1].focus();
          }
        }

        // Check if all inputs are filled and update button state
        this.updateVerifyButtonState();
      });
    });

    // Bind verify continue button
    const verifyContinueBtn = this.querySelector('#verify-continue-button');
    if (verifyContinueBtn) {
      verifyContinueBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        await this.verifyCode();
      });
    }

    // Bind resend code link
    const resendCodeLink = this.querySelector('.resend-code-link');
    if (resendCodeLink) {
      resendCodeLink.addEventListener('click', async (e) => {
        e.preventDefault();
        this.showError('Resend functionality is not available at this time.');
      });
    }

    // Bind password toggle buttons (eye icon with slash state)
    const passwordToggles = this.querySelectorAll('.password-toggle');
    passwordToggles.forEach(toggle => {
      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        const targetId = toggle.getAttribute('data-target');
        const input = this.querySelector(`#${targetId}`);
        if (!input) return;
        const isPassword = input.type === 'password';
        input.type = isPassword ? 'text' : 'password';

        // Toggle visual state (slash through icon)
        if (isPassword) {
          toggle.classList.add('password-toggle--active');
        } else {
          toggle.classList.remove('password-toggle--active');
        }

        // Toggle text label if present (Show / Hide)
        const labelSpan = toggle.querySelector('.login-hide-toggle__label') || toggle.querySelector('span');
        if (labelSpan) {
          labelSpan.textContent = isPassword ? 'Hide' : 'Show';
        }
      });
    });

    // Bind reset password button
    const resetPasswordBtn = this.querySelector('#reset-password-button');
    if (resetPasswordBtn) {
      resetPasswordBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        await this.resetPassword();
      });

      // Initialize reset button disabled state based on inputs
      const codeInput = this.querySelector('#ResetCode');
      const newPassInput = this.querySelector('#NewPassword');
      const confirmInput = this.querySelector('#ConfirmPassword');
      const updateState = () => this.updateResetButtonState();
      [codeInput, newPassInput, confirmInput].forEach(input => {
        if (input) {
          input.addEventListener('input', updateState);
        }
      });
      this.updateResetButtonState();
    }

    // Bind delivery options radio buttons
    const deliveryRadios = this.querySelectorAll('.delivery-radio');
    deliveryRadios.forEach(radio => {
      radio.addEventListener('change', (e) => {
        // Update selected state styling
        const option = e.target.closest('.delivery-option');
        document.querySelectorAll('.delivery-option').forEach(opt => {
          opt.classList.remove('selected');
        });
        option.classList.add('selected');
      });
    });

    // Bind send code button
    const sendCodeBtn = this.querySelector('#send-code-button');
    if (sendCodeBtn) {
      sendCodeBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        await this.sendSignupCode();
      });
    }

    // Bind continue shopping button
    const continueShoppingBtn = this.querySelector('#continue-shopping-button');
    if (continueShoppingBtn) {
      continueShoppingBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.closeModal();
      });
    }


  }

  bindCloseButton() {
    const closeBtn = this.querySelector('.customer-modal-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        this.closeModal();
      });
    }
  }

  bindExternalTriggers() {
    // Handle external login/signup triggers
    document.addEventListener('click', (e) => {
      const loginTrigger = e.target.closest('[data-customer-login-trigger]');
      const signupTrigger = e.target.closest('[data-customer-signup-trigger]');

      const isLoggedIn = typeof window.customer !== 'undefined' && window.customer;

      if (loginTrigger) {
        if (!isLoggedIn) {
          e.preventDefault();
          e.stopPropagation();
          console.log('Login trigger clicked, opening modal:', this);
          this.openModal('login');
        } else {
          // Redirect logged-in user to /account
          e.preventDefault();
          window.location.href = '/account';
        }
      }

      if (signupTrigger) {
        if (!isLoggedIn) {
          e.preventDefault();
          e.stopPropagation();
          console.log('Signup trigger clicked, opening modal:', this);
          this.openModal('signup');
        } else {
          // Hide or disable signup button for logged-in users
          e.preventDefault();
        }
      }
    });
  }


  bindNavigation() {
    // Handle navigation between all sections
    const recoverLink = this.querySelector('.recover-password-link');
    const backToLoginLink = this.querySelector('.back_to_login');
    const switchToSignupLink = this.querySelector('.switch-to-signup');
    const switchToLoginLink = this.querySelector('.switch-to-login');

    if (recoverLink) {
      recoverLink.addEventListener('click', (e) => {
        e.preventDefault();
        // Prefill recover email from login email, and store for reset flow
        const loginEmailInput = this.querySelector('#CustomerEmail');
        const recoverEmailInput = this.querySelector('#RecoverEmail');
        const value = loginEmailInput && loginEmailInput.value.trim();
        if (value) {
          if (recoverEmailInput) recoverEmailInput.value = value;
          this.userEmail = value;
        }
        this.showForm('recover');
      });
    }

    if (backToLoginLink) {
      backToLoginLink.addEventListener('click', (e) => {
        e.preventDefault();
        this.showForm('login');
      });
    }

    if (switchToSignupLink) {
      switchToSignupLink.addEventListener('click', (e) => {
        e.preventDefault();
        // Start the new signup flow - show signup input screen
        this.showSignupInputScreen();
      });
    }

    if (switchToLoginLink) {
      switchToLoginLink.addEventListener('click', (e) => {
        e.preventDefault();
        this.showForm('login');
      });
    }
  }

  openModal(formType = 'login') {
    console.log('Opening modal with form type:', formType, 'Instance:', this);

    // Close any other active modal first
    if (activeModal && activeModal !== this) {
      console.log('Closing other active modal');
      activeModal.closeModal();
    }

    // Set this as the active modal
    activeModal = this;

    // Show the modal
    this.classList.add('active');
    this.isActive = true;

    // Show the correct form
    this.showForm(formType);
  }

  closeModal() {
    console.log('Closing modal:', this);
    this.classList.remove('active');
    this.isActive = false;

    // Clear active modal if this was the active one
    if (activeModal === this) {
      activeModal = null;
    }

    // Reset login + recover/reset flow state so next open starts from the first step
    try {
      this.isForcedPasswordResetFlow = false;
      this.applyRecoverCopy();
      // Clear generic field errors and messages
      this.hideError && this.hideError();
      const errorMsgs = this.querySelectorAll('.field-error-message');
      errorMsgs.forEach(el => el.remove());

      // Reset email + password inputs
      const emailInput = this.querySelector('#CustomerEmail');
      const passwordInput = this.querySelector('#CustomerPassword');
      if (emailInput) {
        emailInput.value = '';
        emailInput.classList.remove('field-error');
        emailInput.placeholder = 'Enter phone number or email address';
      }
      if (passwordInput) {
        passwordInput.value = '';
        passwordInput.classList.remove('field-error');
      }

      // Hide password step and forgot-password link
      const passwordField = this.querySelector('.login_field.next-step');
      const submitBtn = this.querySelector('.field-other.next-step');
      const forgotLinkWrap = this.querySelector('#login-forgot-password-wrap');
      const loginHeading = this.querySelector('.login_title-info');

      if (passwordField) {
        passwordField.classList.add('hide');
      }
      if (submitBtn) {
        submitBtn.classList.add('hide');
      }
      if (forgotLinkWrap) {
        forgotLinkWrap.classList.add('hide');
        forgotLinkWrap.style.display = 'none';
      }
      if (loginHeading) {
        loginHeading.classList.remove('hide');
      }

      // Clear recover + reset form values and messages
      const recoverEmailInput = this.querySelector('#RecoverEmail');
      if (recoverEmailInput) recoverEmailInput.value = '';

      const resetCodeInput = this.querySelector('#ResetCode');
      const newPassInput = this.querySelector('#NewPassword');
      const confirmPassInput = this.querySelector('#ConfirmPassword');
      [resetCodeInput, newPassInput, confirmPassInput].forEach((inp) => {
        if (inp) inp.value = '';
      });

      const recoverError = this.querySelector('#recover-error');
      if (recoverError) recoverError.textContent = '';

      const loginRecoverSuccess = this.querySelector('.login-recover-success');
      if (loginRecoverSuccess) {
        loginRecoverSuccess.innerHTML = '';
        loginRecoverSuccess.style.display = 'none';
      }

      // Reset internal form tracking
      this.currentForm = 'login';
      this.userEmail = '';
      this.customerEmail = '';

      // Ensure login form is the one shown next time
      this.hideAllForms();
      this.showForm('login');
    } catch (e) {
      console.error('Error resetting login modal state on close:', e);
    }
  }

  showForm(formType) {
    console.log('Showing form:', formType, 'in modal:', this);

    // Hide all forms first
    this.hideAllForms();

    // Toggle Welcome logo/title visibility: hide when showing recover/reset (they have their own titles)
    if (this.wrapper) {
      if (formType === 'recover' || formType === 'reset') {
        this.wrapper.classList.add('modal-show-recover');
      } else {
        this.wrapper.classList.remove('modal-show-recover');
      }
    }

    // Show the requested form
    switch (formType) {
      case 'login':
        if (this.loginForm) {
          this.loginForm.style.display = 'block';
          console.log('Login form displayed in modal:', this);
        }
        this.currentForm = 'login';
        break;

      case 'recover':
        if (this.recoverContainer) {
          this.recoverContainer.style.display = 'block';
          console.log('Recover form displayed in modal:', this);
        }
        this.applyRecoverCopy();
        this.hideRecoverError();
        const loginSuccessEl = this.querySelector('#login-recover-success');
        if (loginSuccessEl) {
          loginSuccessEl.innerHTML = '';
          loginSuccessEl.style.display = 'none';
        }
        this.currentForm = 'recover';
        break;
      case 'verify':
        if (this.verifyForm) {
          this.verifyForm.style.display = 'block';
          console.log('Verification form displayed in modal:', this);
        }
        this.currentForm = 'verify';
        break;
      case 'reset':
        if (this.resetForm) {
          this.resetForm.style.display = 'block';
          console.log('Password reset form displayed in modal:', this);
        }
        this.currentForm = 'reset';
        break;
      case 'delivery':
        if (this.deliveryForm) {
          this.deliveryForm.style.display = 'block';
          console.log('Delivery options form displayed in modal:', this);
        }
        this.currentForm = 'delivery';
        break;
      case 'success':
        if (this.successForm) {
          this.successForm.style.display = 'block';
          console.log('Success form displayed in modal:', this);
        }
        this.currentForm = 'success';
        break;
    }
  }

  hideAllForms() {
    console.log('Hiding all forms in modal:', this);

    // Hide recover password form
    if (this.recoverContainer) {
      this.recoverContainer.style.display = 'none';
    }
    // Hide login form
    if (this.loginForm) {
      this.loginForm.style.display = 'none';
    }

    // Hide verification form
    if (this.verifyForm) {
      this.verifyForm.style.display = 'none';
    }
    // Hide password reset form
    if (this.resetForm) {
      this.resetForm.style.display = 'none';
    }
    // Hide delivery options form
    if (this.deliveryForm) {
      this.deliveryForm.style.display = 'none';
    }
    // Hide success form
    if (this.successForm) {
      this.successForm.style.display = 'none';
    }
  }

  // Legacy methods for backward compatibility
  showRecoverSection() {
    this.showForm('recover');
  }

  showLoginSection() {
    this.showForm('login');
  }
}

customElements.define('customer-account-modal', CustomerAccountModal);

// Debug function to check for multiple modals
function debugModals() {
  const modals = document.querySelectorAll('customer-account-modal');
  console.log('Found', modals.length, 'modal instances:');
  modals.forEach((modal, index) => {
    console.log(`Modal ${index + 1}:`, modal);
    console.log(`  - Active:`, modal.isActive);
    console.log(`  - Current form:`, modal.currentForm);
  });
}

// Run debug on page load
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(debugModals, 1000);
});
